import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TravelHotelService from "../../services/travelhotel.service";

/* =================== Thunks =================== */

export const gettravelHotel = createAsyncThunk(
  "travelHotel/gettravelHotel",
  async (params, thunkAPI) => {
    try {
      const response = await TravelHotelService.gettravelHotel(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

export const addtravelHotel = createAsyncThunk(
  "travelHotel/addtravelHotel",
  async (data, thunkAPI) => {
    try {
      const response = await TravelHotelService.addtravelHotel(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

export const updatetravelHotel = createAsyncThunk(
  "travelHotel/updatetravelHotel",
  async (payload, thunkAPI) => {
    try {
      const response = await TravelHotelService.edittravelHotel(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

export const deletetravelHotel = createAsyncThunk(
  "travelHotel/deletetravelHotel",
  async (id, thunkAPI) => {
    try {
      await TravelHotelService.deletetravelHotel(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  travelHotelList: [],
  updateSuccess: false,
  fetched: false,
};

/* =================== Slice =================== */

const travelHotelSlice = createSlice({
  name: "travelHotel",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(gettravelHotel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gettravelHotel.fulfilled, (state, action) => {
        state.loading = false;
        state.travelHotelList = action.payload?.hotels || [];
      })
      .addCase(gettravelHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addtravelHotel.fulfilled, (state, action) => {
        const newHotel = action.payload?.hotel || action.payload;

        if (
          newHotel &&
          !state.travelHotelList.some((h) => h._id === newHotel._id)
        ) {
          state.travelHotelList.unshift(newHotel);
        }
      })

      /* ---------- Update ---------- */
      .addCase(updatetravelHotel.fulfilled, (state, action) => {
        state.updateSuccess = true;

        const updated = action.payload?.hotel || action.payload;

        if (updated?._id) {
          const index = state.travelHotelList.findIndex(
            (h) => h._id === updated._id
          );
          if (index !== -1) {
            state.travelHotelList[index] = updated;
          }
        }
      })

      /* ---------- Delete ---------- */
      .addCase(deletetravelHotel.fulfilled, (state, action) => {
        state.travelHotelList = state.travelHotelList.filter(
          (h) => h._id !== action.payload
        );
      });
  },
});

export const { resetUpdateStatus } = travelHotelSlice.actions;
export default travelHotelSlice.reducer;
